import styled, { css } from 'styled-components';
import bgScribble from './media/bg-scribble.svg';
import bgBanner from './media/bg-banner-bottom.png';

export const BannerWrapper = styled.div`
  ${({ theme }) => css`
    background: linear-gradient(90deg, #124CFF 0%, #0095FF 100%);
    font-family: ${theme.v2.font.family.primary};
    overflow: hidden;
    width: 100%;
    
    @media (min-width: ${theme.v2.breakpoints.md}) {
      border-radius: 16px;
      width: 50%;
    }
  `}
`;

export const BannerContainer = styled.div`
  align-items: center;
  background: url(${bgBanner}) no-repeat left center, url(${bgScribble}) no-repeat left center;
  background-size: 100% auto, 100% auto;
  display: flex;
  justify-content: flex-end;
  height: 100%;
`;

export const WrapperText = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 80px 15px 92px;
    position: relative;
    width: 60%;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      gap: 16px;
      padding: 36px 15px 24px;
    }
  `}
`;

export const Badge = styled.div`
  ${({ theme }) => css`
    background: linear-gradient(180deg, #7BE5A3 0%, #CDFDDD 100%);
    border-radius: 99px;
    color: ${theme.v2.colors.feedback.activeExtraDark};
    font-size: 10px;
    text-align: center;
    font-weight: 500;
    line-height: 1;
    padding: 5px 12px;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      font-size: 8px;
    }
  `}
`;

export const Title = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.bold};
    line-height: 30px;
    max-width: 309px;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.lg}) {
      font-size: ${theme.v2.font.sizes.xxs};
      line-height: 20px;
      max-width: 159px;
    }
  `}
`;

export const WrapperIcon = styled.span`
  height: 24px;
  margin-left: 4px;
`;

export const WrapperButton = styled.div`
  ${({ theme }) => css`
    @media (min-width: ${theme.v2.breakpoints.md}) {
      width: 210px;
    }
  `}
`;
